// EQM2060_R01 - 용수사용. 전력량 등록
import { defaultTqcDailyInspectionDto, TqcDailyInspectionDto } from "src/dtos/tqcDailyInspection/tqcDailyInspectionDto";

export interface EQM2060_R01Dto extends TqcDailyInspectionDto {
	listLength?: number;
	refetchListLength?: number;
	
	// 기본 정보
	compNm: string;					// 사업장명
	dayOfWeek: string;				// 요일

	nickel101: string;				// 니켈1-1 온도
	nickel102: number;				// 니켈1-1 습도
	nickel201: string;				// 니켈1-2 온도
	nickel202: number;				// 니켈1-2 습도
	oilWater01: string;				// 유수분리기 온도
	oilWater02: number;				// 유수분리기 습도

}

// 기본값 상수
export const defaultEQM2060_R01Dto: EQM2060_R01Dto = {
	
	...defaultTqcDailyInspectionDto,
	listLength: 0,
	refetchListLength: 0,
	
	compNm: '',
	dayOfWeek: '',

	nickel101: '', // 니켈1-1 온도
	nickel102: 0, // 니켈1-1 습도
	nickel201: '', // 니켈1-2 온도
	nickel202: 0, // 니켈1-2 습도
	oilWater01: '', // 유수분리기 온도
	oilWater02: 0, // 유수분리기 습도

};

